import React from 'react';
import PropTypes from 'prop-types';

export const Operators = ({ width, height, ...props }) =>
  (
    <svg
      data-icon='operators'
      xmlns='http://www.w3.org/2000/svg'
      width={ width }
      height={ height }
      fill='none'
      viewBox='0 0 24 24'
      { ...props }
    >
      <path
        fill='currentColor'
        d='M14 20v-.575a1.993 1.993 0 0 1 1.225-1.85c.467-.183.92-.325 1.362-.425.442-.1.938-.15 1.488-.15.483 0 .958.05 1.425.15.467.1.892.242 1.275.425A1.993 1.993 0 0 1 22 19.425V20h-8Zm4-4c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 16 14c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 18 12c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412 0 .55-.196 1.02-.587 1.412A1.926 1.926 0 0 1 18 16ZM5 21c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h14c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5v5.65a5.98 5.98 0 0 0-.975-.363A8.268 8.268 0 0 0 19 10.075V5H5v9h4.2c.15.45.4.842.75 1.175.35.333.742.567 1.175.7-.05.333-.083.67-.1 1.012-.017.342 0 .68.05 1.013a4.992 4.992 0 0 1-1.688-.662A5.429 5.429 0 0 1 8 16H5v3h6.325c.117.367.25.717.4 1.05.15.333.333.65.55.95H5ZM7 8.75h10v-2H7v2Zm0 3.5h5.925a6.87 6.87 0 0 1 1.512-1.225 7.477 7.477 0 0 1 1.813-.775H7v2Z'
      />
    </svg>
  );

Operators.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Operators.defaultProps = {
  width: 24,
  height: 24,
};
